<template>
  <div>
    <div><strong>{{title}}</strong></div>
    <div>{{currentDate}}</div>
    <div>{{organization}}</div>
    <div>{{premeeting}}</div>
    <div>{{adress}}</div>
  </div>
</template>

<script>
export default {
  name:"Meeting",
  props:{
    title: String,
    date: String,
    time: String,
    organization: String,
    premeeting: String,
    adress: String
  },
  computed:{
    currentDate(){
        return this.date + " " + this.time;
    }
  }
}
</script>
